// extracted by mini-css-extract-plugin
export default {"card":"TWyjDrsX","content":"LQixGTlY","rubric":"n6WelxJ1","body":"vehQRmWP","image":"_R1pDZmy"};